import React, { FunctionComponent } from "react";
import { ResizableBox } from "react-resizable";
import { Box } from "@mui/material";

import { usePdfPreviewLayout } from "./usePdfPreviewLayout";

import { PdfRenderProps } from "./types";
import { PDF_DOCUMENT_DEFAULT_WIDTH } from "../consts";

export const PdfRender: FunctionComponent<PdfRenderProps> = ({
  downloadUrl,
  children,
  headerSize = 0,
  sx,
}) => {
  const { resizeWidth, windowHeight, containerRef, onResize } =
    usePdfPreviewLayout({ footerHeight: 66, headerHeight: headerSize });

  return (
    <ResizableBox
      height={windowHeight}
      width={resizeWidth}
      onResize={onResize}
      minConstraints={[PDF_DOCUMENT_DEFAULT_WIDTH, windowHeight]}
      maxConstraints={[900, windowHeight]}
      resizeHandles={["e"]}
    >
      <Box
        ref={containerRef}
        sx={{
          display: "flex",
          backgroundColor: downloadUrl ? "#e3e3e3" : "transparent",
          borderRadius: 2,
          padding: 2,
          minWidth: PDF_DOCUMENT_DEFAULT_WIDTH,
          height: "100%",
          overflow: "auto",
          boxSizing: "border-box",
          justifyContent: downloadUrl ? "flex-start" : "center",
          alignItems: downloadUrl ? "flex-start" : "center",
          ...sx,
        }}
      >
        {children}
      </Box>
    </ResizableBox>
  );
};
